import { Component, inject } from '@angular/core';
import { ContractMasterGroupService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ContractMasterGroupCreateDto,
  ContractMasterGroupDto,
  ContractMasterGroupExcelDownloadDto,
  ContractMasterGroupUpdateDto,
} from '../proxy/controlling/dtos/contract-master-group';
import { CONTRACTMASTERGROUP_CONFIG, CONTRACTMASTERGROUP_FIELDS } from './contract-master-group.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-contract-master-group',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ContractMasterGroupService, ConfirmationService],
  templateUrl: './contract-master-group.html',
  styleUrl: './contract-master-group.scss',
})
export class ContractMasterGroup extends BaseCrudComponent<
  ContractMasterGroupDto,
  ContractMasterGroupCreateDto,
  ContractMasterGroupUpdateDto,
  ContractMasterGroupExcelDownloadDto
> {
  service = inject(ContractMasterGroupService);
  config = CONTRACTMASTERGROUP_CONFIG;
  fields = CONTRACTMASTERGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: ContractMasterGroupDto): ContractMasterGroupUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ContractMasterGroup';
  }
}
